import type { GlobalSearch } from '#shared/utils/solr-search'
import type { InferOutput } from 'valibot'
import type { RouteLocationRaw } from 'vue-router'
import { globalSearchSchema } from '#shared/utils/solr-search'
import { pipe, transform } from 'valibot'
import { getSolrDocumentAuthor, getSolrDocumentDate } from '~~/shared/utils/solr'
import { normalizeJuridikaImageUrl } from './juridika-media-image'
import { resolveTitle } from './search-utils'

export const searchResultSchema = pipe(
  globalSearchSchema,
  transform((doc: GlobalSearch) => {
    const { title, subTitle, journalIssueTitle } = resolveTitle(doc)
    const coverImage = normalizeJuridikaImageUrl(doc.coverImage)

    const base = {
      id: doc.id,
      title,
      subTitle,
      ...(journalIssueTitle !== undefined ? { journalIssueTitle } : {}),
      nodeType: doc.nodeType,
      bodytext: doc.bodytext,
      author: getSolrDocumentAuthor(doc),
      publishedAt: getSolrDocumentDate(doc) || undefined,
      image: coverImage || (Array.isArray(doc.image) ? doc.image[0] : doc.image) || undefined,
    }

    return {
      ...base,
      rootId: doc.rootId || undefined,
      issue: doc.issue || undefined,
      volume: doc.volume || undefined,
      lawId: doc.lawId || undefined,
      publisherId: doc.publisherId || undefined,
      lawFragmentId: doc.lawFragmentId || undefined,
      remoteId: doc.remoteId || undefined,
      abstract: doc.abstract || undefined,
      legal_areas: doc.legal_areas || undefined,
      ezMainNodeId: doc.ezMainNodeId || undefined,
      chapterTitle: doc.chapterTitle || undefined,
      paragraphTitle: doc.paragraphTitle || undefined,
      editionNumber: doc.editionNumber || undefined,
    }
  }),
)

export type SearchResult = InferOutput<typeof searchResultSchema>

export type EnrichedSearchResult = SearchResult & {
  highlightedTitle: string
  highlightedBody: string
  previewHighlightedTitle: string
  url: RouteLocationRaw | undefined
}
